import React, { useState } from "react";
import * as styles from "./FAQ.module.css";
import arrow from "../../../static/icons/arrow_down.svg";
import sanitizeHtml from "sanitize-html";

export default function FAQ({ question, answer }) {
  let [open, setOpen] = useState(false);
  const cleanAnswer = sanitizeHtml(answer);
  return (
    <div className={styles.container} onClick={() => {
      setOpen(!open);
    }}>
      <div className={styles.question}>
        <p className={styles.question_text}>{question}</p>
        <img className={`${styles.arrow} ${open && styles.arrow_reverted}`} src={arrow}  alt="arrow"/>
      </div>
      <div className={`${styles.answer} ${open && styles.answer_expanded}`} dangerouslySetInnerHTML={{__html: cleanAnswer}}/>
    </div>
  );
}
